import {Component, Input, OnInit} from '@angular/core';

@Component({
  templateUrl: 'searchresult.component.html',
  selector: 'searchresult-component',
  styleUrls: ['searchresult.less']
})

export class SearchresultComponent implements OnInit {

  // constructor(){}

  @Input() data;

  @Input() type:string;

  uniqueTreeNames: Array<any>;
  uniqueUrls: Array<any>;
  regionsPerTreeName: Array<any> = [];


  ngOnInit() {


    //pluralize
    if(this.type === "driver") {
      this.type = "drivers";
    }

    //pluralize
    if(this.type === "module") {
      this.type = "modules";
    }

    let regionsMap = {
      "e": "family",
      "n": "familyNa",
      "s": "familySa",
      "c": "familyCn",
      "r": "familyRoa"
    };

    let treeNameArray = [];
    if(this.data.family) { treeNameArray.push(this.data.family.treeName); }
    if(this.data.familyNa) { treeNameArray.push(this.data.familyNa.treeName); }
    if(this.data.familySa) { treeNameArray.push(this.data.familySa.treeName); }
    if(this.data.familyCn) { treeNameArray.push(this.data.familyCn.treeName); }
    if(this.data.familyRoa) { treeNameArray.push(this.data.familyRoa.treeName); }


    //remove duplicates from array
    this.uniqueTreeNames = Array.from( new Set(treeNameArray) );

    for(let uniqueTreename of this.uniqueTreeNames ) {
      let temp = [];

      for (let region in regionsMap) {
        if(this.data[regionsMap[region]]) {
          if(this.data[regionsMap[region]].treeName === uniqueTreename) {
            temp.push(region);
          }
        }
      }

      this.regionsPerTreeName.push(temp);
    }

    let urlArray= [];
    if(this.data.family) { urlArray.push(`/#/drilldown/${this.type};parentId=${this.data.family.id}`); }
    if(this.data.familyNa) { urlArray.push(`/#/drilldown/${this.type};parentId=${this.data.familyNa.id}`); }
    if(this.data.familySa) { urlArray.push(`/#/drilldown/${this.type};parentId=${this.data.familySa.id}`); }
    if(this.data.familyCn) { urlArray.push(`/#/drilldown/${this.type};parentId=${this.data.familyCn.id}`); }
    if(this.data.familyRoa) { urlArray.push(`/#/drilldown/${this.type};parentId=${this.data.familyRoa.id}`); }

    //remove duplicates from array
    this.uniqueUrls = Array.from( new Set(urlArray) );
  }



}



// WEBPACK FOOTER //
// ./src/app/_component/searchresult/searchresult.component.ts